import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class FavoritesResolver {
  constructor(connection) {
    this.connection = connection;
  }

  /**
   * Create Favourite for the project
   *  
   * @param {string} accountId
   * @param {string} activityId
   * @param {string} resourceType
   * @param {string} projectId
   * @param {string} workspaceId
   * @returns {Promise.<void>}
   */
  createFavourite = async (accountId, activityId, resourceType, projectId, workspaceId) => {
    const activityResourceType = resourceType?.toUpperCase();
    const message = {
      type: constants.RTM_USER_FAVORITE_CREATE,
      accountId: accountId,
      projectId,
      resourceType: activityResourceType,
      rootElementId: activityId,
      workspaceId,
    };

    if(activityResourceType === 'LESSON') {
      message.activityId = activityId;
    }

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_USER_FAVORITE_CREATE_OK,
      constants.RTM_USER_FAVORITE_CREATE_ERROR,
    );

    return response;
  };

  /**
   * Remove Favorite for the project
   *  
   * @param {string} accountId
   * @param {string} favoriteId
   * @param {string} rootElementId
   * @returns {Promise.<void>}
   */
  removeFavorite = async (accountId, favoriteId, rootElementId) => {
    const message = {
      type: constants.RTM_USER_FAVORITE_REMOVE,
      accountId: accountId,
      favoriteId: favoriteId,
      rootElementId: rootElementId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_USER_FAVORITE_REMOVE_OK,
      constants.RTM_USER_FAVORITE_REMOVE_ERROR,
    );

    return response;
  }; 

  /**
   * Get Favourites for the user
   *  
   * @param {string} accountId
   * @returns {Promise.<void>}
   */
  getFavourites = async (accountId) => {
    const message = {
      type: constants.RTM_GET_USER_FAVORITE,
      accountId: accountId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_GET_USER_FAVORITE_OK,
      constants.RTM_GET_USER_FAVORITE_ERROR,
    );

    return response;
  };
}

export default FavoritesResolver;
